var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgExpand = function SvgExpand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.775 13.214c0-.158.058-.316.183-.441l5.434-5.434a2.283 2.283 0 0 1 3.216 0l5.434 5.434a.629.629 0 0 1 0 .883.629.629 0 0 1-.884 0l-5.433-5.433c-.4-.4-1.05-.4-1.45 0l-5.433 5.433a.629.629 0 0 1-.884 0 .655.655 0 0 1-.183-.442Z"
  })));
};
export default SvgExpand;